// eslint-disable-next-line no-redeclare
import _ from 'lodash';
import { validateUrl } from '@hotjar/insights-common/lib/url';

/**
 * Site service which returns data related to a Site.
 */
angular
    .module('hjApp.account')
    .service(
        'Site',
        function ($rootScope, $q, restDefaultHandlers, Account, Notify, Plan, Restangular, Track, User, UserData) {
            /*************************
             * PUBLIC ACCESS FUNCTIONS
             *************************/

            /**
             * Get a site based on it's ID.
             *
             * @param siteId ID of account to get data for.
             */
            this.get = function (siteId) {
                return UserData.getSites().then(function (sites) {
                    return _.find(sites, { id: siteId });
                });
            };

            /**
             * Returns true if the user is the account owner for a site's account.
             *
             * @param site Site to check owner for. Defaults to currentSite.
             */
            this.isOwner = function (site) {
                var user = User.get();

                site = site || UserData.currentSite;

                return _.includes(site.account.admin_ids, user.id);
            };

            /**
             * Returns the site's account object.
             *
             * @param site Site to check owner for. Defaults to currentSite.
             */
            this.getAccount = function (site) {
                var account = null;

                site = site || UserData.currentSite;

                if (site) {
                    // Clone as to not modify the site's view of the account
                    // NOTE: This is a subset of the actual account as it includes no billing information.
                    account = _.cloneDeep(site.account);

                    // Check if the current user is also the account owner.
                    // In this case extend account with the full account object, which includes billing information.
                    account = _.extend(account, Account.get(site.account.id) || {});
                }

                return account;
            };

            /**
             * Returns whether the site has legal details set.
             *
             * @param site Site to check for. Defaults to currentSite.
             * @returns {boolean} True if both legal_name and privacy_policy_url is set.
             */
            this.hasLegalDetails = function (site) {
                site = site || UserData.currentSite;

                if (!site.legal_name || !site.privacy_policy_url) {
                    return false;
                }

                // Only return true if the legal name and url are "valid".
                return site.legal_name.length > 0 && validateUrl(site.privacy_policy_url);
            };

            /**
             * Send an upgrade or downgrade request email to site admins
             * @param site Site to update plan.
             * @param chosenPlanId The ID of the plan selected to request
             * @param requestedFrom The place from where the update was requested.
             */
            this.requestPlanUpdate = function requestPlanUpdate(site, chosenPlanId, requestedFrom) {
                var rAccount = Restangular.one('accounts', site.account.id),
                    rSite = rAccount.one('sites', site.id);

                return rSite
                    .customPOST({
                        action: 'request_plan_update',
                        plan_id: chosenPlanId,
                        ui_location_requested_from: requestedFrom
                    })
                    .then(function (res) {
                        var updateType = Plan.gt(chosenPlanId, site.plan_id) ? 'Upgrade' : 'Downgrade';
                        if (res.success) {
                            Notify.success(updateType + ' request sent to account owner.');
                            return $q.resolve();
                        } else {
                            Notify.error(updateType + ' request failed: ' + res.error_message);
                            return $q.reject();
                        }
                    }, restDefaultHandlers.onError);
            };
        }
    );
